module.exports = __webpack_public_path__ + "img/ls.d7070190.jpg";